import React from 'react'

export default function AnimatedEllipsis() {
  return (
    <span className='after:animate-ellipsis after:block after:w-[0px] after:overflow-hidden after:align-bottom after:content-["\\\\2026"]' />
  )
}
